// extracted by mini-css-extract-plugin
module.exports = {"filterTagsContainer":"_3nuzNTxYYfyegbyKl5gs59","title":"_27LHArDMoDQxTancKkDrk1"};